import React, { useState } from 'react';

import * as amplitude from '@amplitude/analytics-browser';

import {
    Form,
    FormInput,
    Validate,
} from 'wanderu-component-form';
import {
    Section,
    Typography,
    WDSButton,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { trackEmailSignup } from 'wanderu-service-analytics';

import chiku from './chiku-newsletter.png';

import styles from './NewsletterSubscription.scss';

import type { TFunction } from 'i18next';

interface NewsletterSubscriptionProps {
    destinationCity: string | undefined;
    locale: string;
    mode: string;
    originCity: string | undefined;
    t: TFunction;
}

export const NewsletterSubscription = ({
    destinationCity,
    locale,
    mode,
    originCity,
    t,
}: NewsletterSubscriptionProps) => {
    const [email, setEmail] = useState<string>();
    const [isSubscribed, setIsSubscribed] = useState(false);

    const onClick = () => {
        trackEmailSignup({
            email,
            extra: {
                destination_city: destinationCity,
                origin_city: originCity,
                transport_mode: mode,
            },
            locale,
            // Same surface, same label as the nexus-served C2C pages: this form and
            // that one are the same signup to anyone segmenting on it downstream.
            signupSource: 'landing_c2c',
        });

        amplitude.track('email_newsletter_subscribed', {
            destinationCity,
            email,
            mode,
            originCity,
            source: 'c2c',
        });

        setIsSubscribed(true);
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e?.target?.value);
    };

    return (
        <Section classes={{ content: styles.content }} id="newsletter-section">
            <img src={chiku} width={400} />

            <Form className={styles.form}>
                <Typography className={styles.header} variant="h2">
                    {t('newsletter-header')}<br />
                    {t('newsletter-header1')}
                </Typography>

                <Typography className={styles.subtitle}>
                    {t('newsletter-copy')}
                </Typography>

                <Validate
                    key="email"
                    type="email"
                    value={email}
                    required
                >
                    <FormInput
                        className={styles.input}
                        name="emailAddress"
                        onChange={onChange}
                        placeholder={t('email')}
                        type="email"
                    />
                </Validate>

                <div className={styles.buttonContainer}>
                    <WDSButton disabled={isSubscribed} onClick={onClick} type="submit">
                        {t('subscribe')}
                    </WDSButton>
                    {isSubscribed
                        ? <Typography className={styles.subscribed} variant="caption">{t('subscribe-success')}</Typography>
                        : ''}
                </div>
            </Form>
        </Section>
    );
};
export default localize(NewsletterSubscription, ['t'], 'baseApp');
